import { ValidatorService } from '../tools/validator.service';
import { AutenticacionService } from '../autenticacion.service';
import { Http } from '@angular/http';
import { ConstantsService } from '../constants.service';
import { Injectable } from '@angular/core';
import { ErrorsService } from '../tools/errors.service';

@Injectable()
export class ComercializacionService {

  private service_url : string = '';
  constructor(
      private constantsService: ConstantsService, 
      private http: Http, 
      private authService: AutenticacionService, 
      private validatorService: ValidatorService, 
      private errorService: ErrorsService) {
    this.service_url = this.constantsService.apiURL + '/creditosComercializaciones';
  }

  public save( credito : object) {
    return this.http.post(this.service_url , credito, this.authService.getAuthHeaders());
  }

  public update( credito : object) {
    return this.http.put(this.service_url , credito, this.authService.getAuthHeaders());
  }

  public get(idCreditos : number){
    const service = this.service_url + '/' + idCreditos;
    return this.http.get(service  , this.authService.getAuthHeaders());
  }

  public validate(credito : any){
    let error = [];
    let prestamo = credito.prestamo;
    let cliente = credito.cliente;
    let meses = credito.meses;

    if(!this.validatorService.required(meses.precio_venta)){
        error["precio_venta"] = this.errorService.required;
    }

    if(!this.validatorService.required(prestamo.plazo_periodo)){
        error["plazo_periodo"] = this.errorService.required;
    }

    if(!this.validatorService.required(cliente.nombre)){
        error["nombre"] = this.errorService.required;
    }

    if(!this.validatorService.required(cliente.email)){
        error["email"] = this.errorService.required;
    }else if (!this.validatorService.email(cliente.email)) {
        error['email'] = this.errorService.email;
    }

    if(!this.validatorService.required(meses.precio_compra)){
        error["precio_compra"] = this.errorService.required;
    }

    //Validar que el monto del prestamo sea mayor o igual al precio de compra
    if(meses.precio_venta && meses.precio_compra 
      && Number(meses.precio_venta) < Number(meses.precio_compra))
    {
      error["precio_venta"] = "El precio de venta debe ser mayor o igual al precio de compra";
    }

    //Validar que el monto del prestamo sea mayor o igual al precio de compra
    if(meses.precio_venta && meses.enganche 
      && Number(meses.precio_venta) < Number(meses.enganche))
    {
      error["enganche"] = "El enganche no debe ser mayor al precio de venta";
    }

    return error;
  }

  /**
   * Subproducto functions
   */
  public updateSubproducto( credito : object) {
    let serviceUrl = this.service_url + '/subproductos';
    return this.http.put(serviceUrl , credito, this.authService.getAuthHeaders());
  }

  public validateSubproducto(credito : any){
    let error = [];

    if(!this.validatorService.required(credito.descripcion)){
        error["descripcion"] = this.errorService.required;
    }

    return error;
  }

}


// WEBPACK FOOTER //
// ./src/app/services/creditos/comercializacion.service.ts